// import PropTypes from "prop-types";
import BasicReactTableWrapper from "../../../shared_components/basic_react_table_wrapper";

class CitiesHistogramTable extends BasicReactTableWrapper {
  labelColumnIndex(i) {
    return i < 2;
  }

  decimals() {
    return 0;
  }
}

CitiesHistogramTable.propTypes = Object.assign({}, BasicReactTableWrapper.propTypes, {
});


export default CitiesHistogramTable;
